'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../styleInject.js');

var css_248z = ".TrackingEventsLastUpdated-module_refreshIconWrapper__J4487{display:flex;margin-left:.25rem}";
var styles = {"refreshIconWrapper":"TrackingEventsLastUpdated-module_refreshIconWrapper__J4487"};
styleInject["default"](css_248z, '3cf06646-054f-424f-a092-f3bca01f54d2');

exports["default"] = styles;
